import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  backButton: {
    float: "left"
  },
  header: {},
  root: {
    display: "flex",
    flexFlow: "column",
    height: "100%",
    overflow: "hidden"
  },
  menuList: {
    overflow: "auto"
  }
}));
